import React from 'react';

const STATUS_CONFIG = {
  completed:    { icon: 'CheckCircle2', color: 'var(--color-success, #10b981)',  bg: 'rgba(16,185,129,0.1)',  label: 'Completed'   },
  processing:   { icon: 'Clock',        color: 'var(--color-warning, #f59e0b)',  bg: 'rgba(245,158,11,0.1)', label: 'Processing'  },
  failed:       { icon: 'XCircle',      color: 'var(--color-error, #ef4444)',    bg: 'rgba(239,68,68,0.1)',  label: 'Failed'      },
  pending:      { icon: 'Loader',       color: 'var(--color-primary, #1e3a5f)',  bg: 'rgba(30,58,95,0.1)',   label: 'Pending'     },
  'in-progress':{ icon: 'RefreshCw',    color: 'var(--color-primary, #1e3a5f)',  bg: 'rgba(30,58,95,0.1)',   label: 'In Progress' },
  ready:        { icon: 'CheckCircle',  color: 'var(--color-success, #10b981)',  bg: 'rgba(16,185,129,0.1)', label: 'Ready'       },
  published:    { icon: 'Eye',          color: 'var(--color-info, #3b82f6)',     bg: 'rgba(59,130,246,0.1)', label: 'Published'   },
};

const STATUS_ICONS = {
  CheckCircle2: (c) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/>
      <path d="m9 12 2 2 4-4"/>
    </svg>
  ),
  Clock: (c) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  XCircle: (c) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
    </svg>
  ),
  Loader: (c) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'db-spin 1s linear infinite' }}>
      <line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/>
      <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/>
      <line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/>
      <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/>
    </svg>
  ),
  RefreshCw: (c) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'db-spin 1.5s linear infinite' }}>
      <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
      <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/>
    </svg>
  ),
  CheckCircle: (c) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
  ),
  Eye: (c) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
    </svg>
  ),
  AlertCircle: (c) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  ),
};

const StatusBadge = ({ status }) => {
  const key = status?.toLowerCase();
  const cfg = STATUS_CONFIG[key] || {
    icon: 'AlertCircle',
    color: 'var(--color-muted-foreground, var(--text-3))',
    bg: 'var(--color-muted, var(--input-bg))',
    label: status,
  };
  const IconSvg = STATUS_ICONS[cfg.icon] || STATUS_ICONS.AlertCircle;
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      padding: '6px 12px', borderRadius: 9999,
      fontSize: 12, fontWeight: 500,
      fontFamily: "'DM Sans', sans-serif",
      backgroundColor: cfg.bg, color: cfg.color, whiteSpace: 'nowrap',
    }}>
      {IconSvg(cfg.color)}
      <span>{cfg.label}</span>
    </div>
  );
};

export default StatusBadge;